<app-nav-pages></app-nav-pages>

  <section class="hero-section d-flex justify-content-center align-items-center csr-hero">
    <div class="overlay"></div>
    <div class="hero-text d-flex text-center  align-items-center flex-column gap-5 ">
      <h2>Reach Out Zumera 2022</h2>
    </div>
  </section>
  
  <section class="container context">
    <h2 class="text-center reach_out_header">Embracing Hope</h2>
    <p>Our team’s visit to Oghosa Orphanage radiated warmth, showcasing our dedication to community growth. Engaging with the children underscores our belief in holistic community development, fostering a stronger and more connected society.
    </p>
  </section>

<section class="container ">
  <h1>Pictures from ReachOut Zumera 2022.</h1><hr>
  <div id="gallery" class="container-fluid">  

    <img src="assets/imgs/RO22_1.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO22_2.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO22_3.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO22_4.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO22_5.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO22_6.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
    <img src="assets/imgs/RO22_7.jpg" class="img-responsive" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">

  </div>

  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          
        </div>
      </div>
    </div>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>
  
</section>
<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>